
import { supabase } from './client';

// Utility for handling Supabase storage operations
export const supabaseStorage = {
  upload: async (bucketName: string, path: string, file: File) => {
    return await supabase.storage.from(bucketName).upload(path, file);
  },
  
  getPublicUrl: (bucketName: string, path: string) => {
    return supabase.storage.from(bucketName).getPublicUrl(path);
  },
  
  download: async (bucketName: string, path: string) => {
    return await supabase.storage.from(bucketName).download(path);
  },
  
  remove: async (bucketName: string, paths: string[]) => {
    return await supabase.storage.from(bucketName).remove(paths);
  },
  
  // New utility to ensure avatars bucket is public and properly configured
  ensureAvatarsBucket: async () => {
    try {
      // Call our database function to ensure the bucket is public
      const { data, error } = await supabase.rpc('make_avatars_bucket_public');
      if (error) {
        console.error("Error making avatars bucket public:", error);
        return false;
      }
      console.log("Avatars bucket configuration checked/updated");
      return data || true;
    } catch (error) {
      console.error("Error configuring avatars bucket:", error);
      return false;
    }
  }
};

// Utility for handling Supabase auth operations
export const supabaseAuth = {
  signIn: async (email: string, password: string) => {
    return await supabase.auth.signInWithPassword({ email, password });
  },
  
  signOut: async () => {
    return await supabase.auth.signOut();
  },
  
  getUser: async () => {
    return await supabase.auth.getUser();
  },
  
  onAuthStateChange: (callback: any) => {
    return supabase.auth.onAuthStateChange(callback);
  },
  
  updateUser: async (attributes: any) => {
    return await supabase.auth.updateUser(attributes);
  }
};

// Add this utility function but don't use it in the current implementation
// since we're using public bucket access instead
export const getAuthHeaders = () => {
  const sessionToken = localStorage.getItem('session_token');
  
  if (sessionToken) {
    return {
      Authorization: `Bearer ${sessionToken}`
    };
  }
  
  return {};
};

// Make the avatars bucket public to simplify access - this is the key fix
export const makeAvatarsBucketPublic = async () => {
  try {
    // Create a public bucket with appropriate file size limits
    await supabase.storage.createBucket('avatars', {
      public: true, // This is crucial - make the bucket public
      fileSizeLimit: 1024 * 1024 * 2, // 2MB limit for avatars
    }).catch(error => {
      // If bucket already exists, this is fine
      if (!error.message.includes('already exists')) {
        console.error("Error creating bucket:", error);
      }
    });
    
    console.log("Avatars bucket configuration checked/updated");
    return true;
  } catch (error) {
    console.error("Error configuring avatars bucket:", error);
    return false;
  }
};
